module.exports = __webpack_public_path__ + "img/tickIcon.40490b55.svg";